import {
    breakpointsTailwind,
    createSharedComposable,
    useBreakpoints,
} from '@vueuse/core';
import { computed } from 'vue';

export const useViewport = createSharedComposable(() => {
    const breakpoints = useBreakpoints(breakpointsTailwind);
    const isDesktopView = computed(() => breakpoints.greater('md').value);
    const isTabletView = computed(() => breakpoints.between('md', 'lg').value);
    const isMobileView = computed(() => breakpoints.smaller('md').value);
    const isSmallerScreen = computed(() => breakpoints.smaller('sm').value);
    const isTabletOrBigger = computed(
        () => isDesktopView.value || isTabletView.value,
    );
    const isTabletOrSmaller = computed(
        () => isMobileView.value || isTabletView.value,
    );
    const isMobileOrSmaller = computed(
        () => isMobileView.value || isSmallerScreen.value,
    );

    return {
        isDesktopView,
        isTabletView,
        isMobileView,
        isTabletOrBigger,
        isTabletOrSmaller,
        isSmallerScreen,
        isMobileOrSmaller,
    };
});
